import { render } from "./Notification.vue?vue&type=template&id=3f58aa56&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=3f58aa56&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f58aa56"]])

export default __exports__